import { createContext } from 'react';
import { LayoutState, LayoutAction } from '../types';

type Context = {
    state: LayoutState;
    dispatch: (action: LayoutAction) => void;
}

export const LayoutContext = createContext({} as Context);
